'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/* eslint-disable react/prop-types */


exports.default = function (props) {
  return _react2.default.createElement(_context2.default.Consumer, null, function (context) {
    return _react2.default.createElement(Query, _extends({}, context, props));
  });
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _prismicJavascript = require('prismic-javascript');

var _prismicJavascript2 = _interopRequireDefault(_prismicJavascript);

var _reactJsonView = require('react-json-view');

var _reactJsonView2 = _interopRequireDefault(_reactJsonView);

var _context = require('../Prismic/context');

var _context2 = _interopRequireDefault(_context);

var _resolveMultiPredicates = require('./resolve-multi-predicates');

var _resolveMultiPredicates2 = _interopRequireDefault(_resolveMultiPredicates);

var _shouldFetch = require('./should-fetch');

var _shouldFetch2 = _interopRequireDefault(_shouldFetch);

var _makeCancelablePromise = require('./make-cancelable-promise');

var _makeCancelablePromise2 = _interopRequireDefault(_makeCancelablePromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var VALID_PREDICATES = ['at', 'not', 'any', 'in', 'fulltext', 'has', 'missing', 'similar', 'near', 'lt', 'gt', 'dateAfter', 'dateBefore', 'dayOfMonth', 'dayOfMonthAfter', 'dayOfMonthBefore', 'dayOfWeek', 'dayOfWeekAfter', 'dayOfWeekBefore', 'month', 'monthAfter', 'monthBefore', 'year', 'hour', 'hourAfter', 'hourBefore'];

var Query = function (_Component) {
  _inherits(Query, _Component);

  function Query(props) {
    _classCallCheck(this, Query);

    var _this = _possibleConstructorReturn(this, (Query.__proto__ || Object.getPrototypeOf(Query)).call(this, props));

    _this.state = {
      isLoading: false
    };
    return _this;
  }

  _createClass(Query, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetch();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if ((0, _shouldFetch2.default)(prevProps, this.props)) {
        this.fetch();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cancelablePromise.cancel();
    }
  }, {
    key: 'resolvePredicate',
    value: function resolvePredicate() {
      var _props = this.props,
          predicate = _props.predicate,
          path = _props.path,
          value = _props.value,
          multiPredicates = _props.multiPredicates;

      if (multiPredicates) {
        return (0, _resolveMultiPredicates2.default)(multiPredicates);
      }

      if (predicate === 'inRange') {
        return _prismicJavascript2.default.Predicates.inRange(path, value.lowerLimit, value.upperLimit);
      }

      if (predicate === 'dateBetween') {
        return _prismicJavascript2.default.Predicates.dateBetween(path, value.startDate, value.endDate);
      }

      if (VALID_PREDICATES.indexOf(predicate) !== -1) {
        return _prismicJavascript2.default.Predicates[predicate](path, value);
      }

      return _prismicJavascript2.default.Predicates.at(path, value);
    }
  }, {
    key: 'queryPrismic',
    value: function queryPrismic() {
      var _this2 = this;

      var _props2 = this.props,
          repo = _props2.repo,
          lang = _props2.lang,
          ref = _props2.ref,
          after = _props2.after,
          fetch = _props2.fetch,
          fetchLinks = _props2.fetchLinks,
          orderings = _props2.orderings,
          page = _props2.page,
          pageSize = _props2.pageSize;
      return _prismicJavascript2.default.getApi('https://' + repo + '.prismic.io/api/v2').then(function (api) {
        return api.query(_this2.resolvePredicate(), {
          after: after,
          fetch: fetch,
          fetchLinks: fetchLinks,
          lang: lang,
          orderings: orderings,
          page: page,
          pageSize: pageSize,
          ref: ref
        });
      });
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this3 = this;

      this.setState({
        isLoading: true
      });
      this.cancelablePromise = (0, _makeCancelablePromise2.default)(this.queryPrismic());
      this.cancelablePromise.promise.then(function (response) {
        _this3.setState({
          response: response,
          isLoading: false
        });
      }).catch(function (error) {
        if (!error.isCanceled) {
          _this3.setState({
            error: error,
            isLoading: false
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          response = _state.response,
          error = _state.error,
          isLoading = _state.isLoading;

      var _props3 = this.props,
          RendererComponent = _props3.component,
          rest = _objectWithoutProperties(_props3, ['component']);

      return _react2.default.createElement(RendererComponent, _extends({}, rest, {
        response: response,
        error: error,
        isLoading: isLoading
      }));
    }
  }]);

  return Query;
}(_react.Component);

Query.propTypes = {
  predicate: _propTypes2.default.oneOf(['at', 'not', 'any', 'in', 'fulltext', 'has', 'missing', 'similar', 'near', 'lt', 'gt', 'inRange', 'dateAfter', 'dateBefore', 'dateBetween', 'dayOfMonth', 'dayOfMonthAfter', 'dayOfMonthBefore', 'dayOfWeek', 'dayOfWeekAfter', 'dayOfWeekBefore', 'month', 'monthAfter', 'monthBefore', 'year', 'hour', 'hourAfter', 'hourBefore']),
  path: _propTypes2.default.string,
  value: _propTypes2.default.any,
  component: _propTypes2.default.func,
  after: _propTypes2.default.string,
  fetch: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  fetchLinks: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  orderings: _propTypes2.default.string,
  page: _propTypes2.default.number,
  pageSize: _propTypes2.default.number,
  multiPredicates: _propTypes2.default.array
};
Query.defaultProps = {
  predicate: 'at',
  path: 'document.type',
  value: '',
  component: function component(_ref) {
    var response = _ref.response;
    return _react2.default.createElement(_reactJsonView2.default, {
      src: response
    });
  },
  after: undefined,
  fetch: undefined,
  fetchLinks: undefined,
  orderings: undefined,
  page: 1,
  pageSize: 20,
  multiPredicates: undefined
};